import {
  ChakraBox,
  DateCell,
  FAIconName,
  FireflyKebabMenu,
  FireflyKebabMenuItem,
  RowObject,
} from '@equip.health/ui';
import { ScriptSureSyncFailure } from '~/store/services/integration';
import { SCRIPTSURE_SYNC_CONSTANTS } from './scriptSureSync.constants';

const { KEBAB_ARIA_LABEL, FIX_PROFILE_LABEL } = SCRIPTSURE_SYNC_CONSTANTS;

export type ScriptSureSyncFailureRow = {
  patientName: string;
  email: string;
  timestamp: React.ReactNode;
  failureReason: string;
  action: React.ReactNode;
};

interface ScriptSureSyncTableRowProps {
  id: string;
  failure: ScriptSureSyncFailure;
  isResyncing: boolean;
  onResync: (failure: ScriptSureSyncFailure) => void;
}

const ScriptSureSyncTableRow = ({
  id,
  failure,
  isResyncing,
  onResync,
}: ScriptSureSyncTableRowProps): RowObject<ScriptSureSyncFailureRow> => {
  const patientName = [failure.firstName, failure.lastName]
    .filter(Boolean)
    .join(' ');

  const kebabOptions: FireflyKebabMenuItem[] = [
    {
      disabled: isResyncing,
      label: FIX_PROFILE_LABEL,
      leftIcon: FAIconName.redoRegular,
      leftIconColor: 'neutral.primary',
      onClick: () => onResync(failure),
    },
  ];

  return {
    key: failure.patientId,
    object: {
      patientName,
      email: failure.email,
      timestamp: failure.updatedAt ? (
        <DateCell
          date={new Date(failure.updatedAt)}
          id={`${id}__timestamp__${failure.patientId}`}
        />
      ) : null,
      failureReason: failure.failureReason,
      action: (
        <ChakraBox
          id={`${id}__action__${failure.patientId}`}
          paddingRight="12px"
        >
          <FireflyKebabMenu
            aria-label={KEBAB_ARIA_LABEL(patientName || failure.email)}
            options={kebabOptions}
          />
        </ChakraBox>
      ),
    },
  };
};

export default ScriptSureSyncTableRow;
